export let mockDocument = {
  id: null,
  type: null,
  identifier: null,
  agentDispatcher: null,
  expedition: null,
  active: true
}
